import { COLORS } from "@/constants/colors";
import { FC } from "react";

type ArrowDownIconProps = React.SVGProps<SVGSVGElement> & {
  disabled?: boolean;
};

export const ArrowDownIcon: FC<ArrowDownIconProps> = ({ disabled, ...props }) => <svg
  {...props}
  width="15"
  height="14"
  viewBox="0 0 15 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M0.799177 3.22653C1.0614 2.9646 1.417 2.81746 1.78778 2.81746C2.15857 2.81746 2.51417 2.9646 2.77639 3.22653L7.38103 7.82747L11.9857 3.22653C12.1147 3.09309 12.269 2.98665 12.4396 2.91342C12.6102 2.8402 12.7936 2.80165 12.9793 2.80004C13.165 2.79843 13.3491 2.83378 13.521 2.90403C13.6928 2.97428 13.8489 3.07803 13.9802 3.20921C14.1115 3.3404 14.2153 3.4964 14.2856 3.66811C14.356 3.83982 14.3913 4.0238 14.3897 4.20932C14.3881 4.39483 14.3495 4.57817 14.2762 4.74864C14.203 4.9191 14.0964 5.07327 13.9629 5.20216L8.36964 10.7909C8.10741 11.0528 7.75181 11.2 7.38103 11.2C7.01025 11.2 6.65465 11.0528 6.39242 10.7909L0.799177 5.20216C0.537034 4.94015 0.389771 4.58483 0.389771 4.21434C0.389771 3.84386 0.537034 3.48854 0.799177 3.22653Z"
    fill={disabled ? COLORS["neutral/300"] : "#BB5337"}
  />
</svg>